@if (open()) {
  <div class="me-overlay" (click)="onClose()">
    <div
      class="me-dialog"
      role="dialog"
      aria-modal="true"
      aria-label="Send an email"
      (click)="$event.stopPropagation()"
    >
      <header class="me-head">
        <div class="me-head-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="5" width="18" height="14" rx="2" /><polyline points="3 7 12 13 21 7" />
          </svg>
        </div>
        <div class="me-head-text">
          <div class="me-title">Send an email</div>
          <div class="me-subtitle">Pages Ready for Review</div>
        </div>
        <button class="me-close" type="button" (click)="onClose()" aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </header>

      <div class="me-body">
        <div class="me-section-label">Review type</div>
        <div class="me-segment" role="radiogroup" aria-label="Review type">
          <button
            type="button"
            role="radio"
            class="me-segment-option"
            [class.me-segment-option--active]="audience() === ReviewAudience.Client"
            [attr.aria-checked]="audience() === ReviewAudience.Client"
            (click)="setAudience(ReviewAudience.Client)"
          >
            Client review
          </button>
          <button
            type="button"
            role="radio"
            class="me-segment-option"
            [class.me-segment-option--active]="audience() === ReviewAudience.Internal"
            [attr.aria-checked]="audience() === ReviewAudience.Internal"
            (click)="setAudience(ReviewAudience.Internal)"
          >
            Internal review
          </button>
        </div>
        @if (audience() === ReviewAudience.Internal) {
          <p class="me-hint">Internal review emails only go to &#64;brafton.com addresses.</p>
        }

        <div class="me-section-label">Pages</div>
        <div class="me-pages">
          @if (!check() && checking()) {
            <span class="me-muted">Checking…</span>
          } @else if (check()?.pages?.length) {
            @for (page of check()!.pages; track page.pageUrl) {
              <div class="me-page">{{ page.pageUrl }}</div>
            }
          } @else {
            <span class="me-muted">No pages are in this review status.</span>
          }
        </div>

        <div class="me-section-label">Project Team</div>
        @if (stakeholderOptions().length) {
          <div class="me-team">
            @for (option of stakeholderOptions(); track option.email) {
              <label class="me-team-row" [class.me-team-row--rejected]="rejectionByEmail().has(option.email) && selectedStakeholders().has(option.email)">
                <input
                  type="checkbox"
                  [checked]="selectedStakeholders().has(option.email)"
                  (change)="toggleStakeholder(option.email)"
                />
                <span class="me-team-name">{{ option.name }}</span>
                <span class="me-team-email">{{ option.email }}</span>
                @if (selectedStakeholders().has(option.email) && rejectionByEmail().get(option.email); as reason) {
                  <span class="me-flag">{{ reason }}</span>
                }
              </label>
            }
          </div>
        } @else {
          <span class="me-muted">Nobody is on the Project Team yet.</span>
        }

        <div class="me-section-label">Other recipients</div>
        <div class="me-addresses">
          @for (address of typedAddresses(); track address) {
            <span class="me-chip" [class.me-chip--rejected]="rejectionByEmail().has(address)" [title]="rejectionByEmail().get(address) ?? ''">
              {{ address }}
              <button type="button" (click)="removeTyped(address)" [attr.aria-label]="'Remove ' + address">×</button>
            </span>
          }
          <input
            class="me-address-input"
            type="text"
            placeholder="Type email addresses, then press Enter"
            [value]="addressDraft()"
            (input)="addressDraft.set($any($event.target).value)"
            (keydown)="onDraftKeydown($event)"
            (blur)="commitDraft()"
            aria-label="Other recipients"
          />
        </div>
        @for (rejection of check()?.rejected ?? []; track rejection.email) {
          @if (typedAddresses().includes(rejection.email)) {
            <p class="me-flag-line">{{ rejection.email }} — {{ rejection.reasonLabel }}</p>
          }
        }
      </div>

      <footer class="me-foot">
        <div class="me-foot-message">
          @if (error()) {
            <span class="me-error">{{ error() }}</span>
          } @else if (blockReason()) {
            <span class="me-blocked">{{ blockReason() }}</span>
          } @else if (check()?.accepted?.length) {
            <span class="me-muted">
              Will be sent to {{ check()!.accepted.length }}
              {{ check()!.accepted.length === 1 ? 'person' : 'people' }}.
            </span>
          }
        </div>
        <button class="me-cancel" type="button" (click)="onClose()" [disabled]="sending()">Cancel</button>
        <button class="me-send" type="button" (click)="send()" [disabled]="!canSend()">
          {{ sending() ? 'Sending…' : 'Send' }}
        </button>
      </footer>
    </div>
  </div>
}
